import React from 'react';
import { Box, Chip, Grid, Typography } from '@mui/material';

interface InfoClientProps {
    client: ClientTableRow;
}

const InfoClient: React.FC<InfoClientProps> = ({ client }) => {
    const grantTypes = (client.grant_types || '')
        .split(',')
        .map((item) => item.trim())
        .filter(Boolean);

    const scopes = (client.scope || '')
        .split(' ')
        .map((item) => item.trim())
        .filter(Boolean);

    const redirectUris = (client.redirect_uri || '')
        .split(',')
        .map((item) => item.trim())
        .filter(Boolean);

    return (
        <Grid container spacing={1.5}>
            <Grid size={4}>
                <Typography fontWeight={700}>Client ID</Typography>
            </Grid>
            <Grid size={8}>
                <Typography
                    component='code'
                    sx={{
                        fontFamily: 'Monaco, Menlo, Consolas, "Liberation Mono", "Courier New", monospace',
                        fontSize: '0.95rem',
                        wordBreak: 'break-all',
                    }}
                >
                    {client.client_id}
                </Typography>
            </Grid>

            <Grid size={4}>
                <Typography fontWeight={700}>Nombre</Typography>
            </Grid>
            <Grid size={8}>
                <Typography>{client.name}</Typography>
            </Grid>

            <Grid size={4}>
                <Typography fontWeight={700}>Owner ID</Typography>
            </Grid>
            <Grid size={8}>
                <Typography>{String(client.owner_id)}</Typography>
            </Grid>

            <Grid size={4}>
                <Typography fontWeight={700}>Grant types</Typography>
            </Grid>
            <Grid size={8}>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75 }}>
                    {grantTypes.length > 0 ? (
                        grantTypes.map((grant) => <Chip key={grant} label={grant} size='small' variant='outlined' />)
                    ) : (
                        <Typography>-</Typography>
                    )}
                </Box>
            </Grid>

            <Grid size={4}>
                <Typography fontWeight={700}>Scope</Typography>
            </Grid>
            <Grid size={8}>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75 }}>
                    {scopes.length > 0 ? (
                        scopes.map((scope) => <Chip key={scope} label={scope} size='small' color='primary' variant='outlined' />)
                    ) : (
                        <Typography>-</Typography>
                    )}
                </Box>
            </Grid>

            <Grid size={4}>
                <Typography fontWeight={700}>Redirect URI</Typography>
            </Grid>
            <Grid size={8}>
                {redirectUris.length > 0 ? (
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                        {redirectUris.map((uri) => (
                            <Typography
                                key={uri}
                                component='code'
                                sx={{
                                    fontFamily: 'Monaco, Menlo, Consolas, "Liberation Mono", "Courier New", monospace',
                                    fontSize: '0.92rem',
                                    wordBreak: 'break-all',
                                }}
                            >
                                {uri}
                            </Typography>
                        ))}
                    </Box>
                ) : (
                    <Typography>-</Typography>
                )}
            </Grid>
        </Grid>
    );
};

export { InfoClient };
